// Datos de demostración del módulo IA Comercial — Punto Cero System OS.
// La IA responde automáticamente (sin contacto humano). FAQ y métricas de uso.

export const FAQ = [
  { q: "¿Qué incluye cada plan?", a: "El Despegue (50 casos, CRM básico, IA redacción), El Salto Estratégico (150 casos, IA documental, video, facturación), Firma en Crecimiento (procesos ilimitados, IA Pro) y Consolidación Empresarial (API, IA ilimitada, SLA)." },
  { q: "¿Cómo funciona el Trial?", a: "3 días con datos reales. Al finalizar, la cuenta pasa a solo lectura hasta activar un plan." },
  { q: "¿Qué límites tiene el Demo?", a: "3 clientes, 2 casos, 10 consultas de IA, 3 citas, 1 videollamada y 5 documentos. Facturación y portal en modo vista previa." },
  { q: "¿Cómo gano meses gratis?", a: "Cada referido que compre en sus primeros 15 días te otorga 1 mes gratis, acumulable (mensual o anual)." },
  { q: "¿Cómo pago?", a: "Tú decides cuándo pagar. No guardamos tarjetas ni hacemos cobros automáticos. Pronto: Mercado Pago, PayPal y Stripe." },
  { q: "¿Las renovaciones son automáticas?", a: "No. Te avisamos cerca del vencimiento y tú decides renovar." },
];

export const KPIS = {
  resolved: 128,
  topics: 6,
  conversions: 14,
  satisfaction: 96,
};

export const TOPICS = [
  { label: "Planes", value: 42 },
  { label: "Trial", value: 28 },
  { label: "Demo", value: 21 },
  { label: "Referidos", value: 19 },
  { label: "Pagos", value: 18 },
];
